import useAuth from "hooks/useAuth";
import { Button } from "./Styled";
import { Link } from "react-router-dom";
import { useERC20Contract } from "hooks/useContract";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { slide as MenuBurger } from "react-burger-menu";

const Menu = () => {
  const { active, account, login, logout } = useAuth();
  const accountConverted = account ? account.toString() : "";
  const erc20 = useERC20Contract();
  const [ERC20Name, setERC20Name] = useState(null);
  const [ERC20Balance, setERC20Balance] = useState(null);
  //const [ERC20Decimals, setERC20Decimals] = useState(null);

  useEffect(() => {
    if (erc20 && active) {
      erc20.symbol().then(setERC20Name);
      erc20
        .decimals()
        .then((decimals) => {
          //setERC20Decimals(decimals);
          return decimals;
        })
        .then((decimals) => {
          erc20.balanceOf(account).then((balance) => {
            const div = ethers.BigNumber.from(10);
            setERC20Balance(balance.div(div.pow(decimals)).toString());
          });
        });
    }
  }, [erc20, active, account]);

  return (
    <div>
      <MenuBurger pageWrapId={`page-wrap`}>
        <Link to="/">Mint</Link>
        {active && (
          <Button className="mr-4 hidden md:block">
            <Link to="/my-punks">My punks</Link>
          </Button>
        )}

        <Link to="/marketplace">MarketPlace</Link>
      </MenuBurger>
      <ul className="absolute right-0 top-0 p-4 text-white z-50 text-sm flex">
        <Button className="mr-4 hidden md:block">
          <Link to="/">Mint</Link>
        </Button>

        {!active && (
          <>
            <Button className="mr-4 hidden md:block">
              <Link to="/marketplace">MarketPlace</Link>
            </Button>
            <Button onClick={() => login()}>Connect wallet</Button>
          </>
        )}
        {active && (
          <>
            <Button className="mr-4 hidden md:block">
              <Link to="/my-punks">My punks</Link>
            </Button>

            {erc20 && (
              <Button className="mr-4">
                Balance: {ERC20Balance} {ERC20Name}
              </Button>
            )}
            <Button className="mr-4 hidden md:block">
              <Link to="/marketplace">MarketPlace</Link>
            </Button>
            <Button className="mr-4">
              0x***
              {accountConverted.slice(
                accountConverted.length - 4,
                accountConverted.length
              )}
            </Button>
            <Button
              onClick={() => {
                logout();
                localStorage.removeItem("login");
              }}
            >
              Disconnect
            </Button>
          </>
        )}
      </ul>
    </div>
  );
};
export default Menu;
